(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anmeldelser"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      root = root || document;
      var els = root.querySelectorAll('.section-anmeldelser .anmeldelser__reveal');
      if (!els.length) return;

      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < els.length; i++) els[i].classList.add('anmeldelser__reveal--visible');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('anmeldelser__reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });

      for (var i = 0; i < els.length; i++) observer.observe(els[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var els = document.querySelectorAll('.faq__reveal');
      if (!els.length) return;

      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < els.length; i++) els[i].classList.add('faq__reveal--visible');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('faq__reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.06, rootMargin: '0px 0px -24px 0px' });

      for (var i = 0; i < els.length; i++) observer.observe(els[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flere-kolonner-cool"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      root = root || document;
      var els = root.querySelectorAll('.section-multicolumn-cool .multicolumn-cool__reveal');
      if (! els.length) return;
      

      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < els.length; i++) 
          els[i].classList.add('multicolumn-cool__reveal--visible');
        
        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('multicolumn-cool__reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -24px 0px'
      });

      for (var j = 0; j < els.length; j++) 
        observer.observe(els[j]);
      
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fordele"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var els = document.querySelectorAll('.fordele__reveal');
      if (!els.length) return;

      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < els.length; i++) els[i].classList.add('fordele__reveal--visible');
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('fordele__reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });

      for (var i = 0; i < els.length; i++) observer.observe(els[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multi-box"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      root = root || document;
      var els = root.querySelectorAll('.section-multi-box .multi-box__reveal');
      if (! els.length) return;
      


      if (!('IntersectionObserver' in window)) {
        for (var i = 0; i < els.length; i++) 
          els[i].classList.add('multi-box__reveal--visible');
        


        return;
      }

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('multi-box__reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -24px 0px'
      });

      for (var j = 0; j < els.length; j++) 
        observer.observe(els[j]);
      


    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        init(document);
      });
    } else {
      init(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
